import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Gift } from "lucide-react";
import { DomainSearch } from "../components/ActionHub";
import { DomainResults } from "../components/DomainResults";
import { useCountry } from "../context/CountryContext";
import { PageHero, IMG } from "../components/PageHero";

export default function Domains() {
  const { country } = useCountry();
  const [data, setData] = useState(null);
  const [sp] = useSearchParams();
  return (
    <div data-testid="domains-page">
      <PageHero eyebrow={`Domains · prices in ${country?.currency || ""}`} title="Claim your name online." tone="mint" img={IMG.domain}
        sub=".africa, .com, .co.za, .ng, .co.ke and more. Registered instantly, renewed automatically.">
        <div className="max-w-2xl rounded-full bg-white p-1.5 shadow-[0_20px_40px_-24px_rgba(27,16,51,0.4)]"><DomainSearch onResult={setData} initial={sp.get("q") || ""} /></div>
        <p className="mt-4 flex items-center gap-2 text-sm font-medium text-foreground/70" data-testid="free-domain-hint">
          <Gift className="h-4 w-4 text-secondary" />
          {`Get a free ${country?.free_tld || ".africa"} domain for a year with any internet or hosting package.`}
        </p>
      </PageHero>
      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6">{data && <DomainResults data={data} />}</section>
    </div>
  );
}
